import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCodeInput]',
  standalone: false
})
export class CodeDirective {

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const initialValue = input.value;
    const newValue = initialValue.replace(/[^a-zA-Z0-9-]/g, '');

    if (initialValue !== newValue) {
      this.control.control?.setValue(newValue);
    }
  }

}
